import { MessageCircle } from "lucide-react";

export default function WhatsAppFloat() {
  const phone = "918770847087";
  const text = encodeURIComponent("Hello Arihant Events! I'd like to plan an event.");
  return (
    <a
      href={`https://wa.me/${phone}?text=${text}`}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      className="fixed z-[70] bottom-6 right-6 h-14 w-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-2xl pulse-ring hover:scale-110 transition-transform duration-300"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle size={26} />
    </a>
  );
}
